/* unplugin-vue-components disabled */import { render } from "./FundpoolUnavailable.vue?vue&type=template&id=48da5e30&scoped=true"
import script from "./FundpoolUnavailable.vue?vue&type=script&lang=js"
export * from "./FundpoolUnavailable.vue?vue&type=script&lang=js"

import "./FundpoolUnavailable.vue?vue&type=style&index=0&id=48da5e30&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../common/temp/node_modules/.pnpm/vue-loader@17.2.2_3tnefydtqxjg44ddub7xm4i2wi/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48da5e30"]])

export default __exports__